import React from 'react';
import { Modal } from 'antd';
import { getSaveWarnings } from '../../utils/paymentConfig';

/** 保存已成功但服务端返回了需要人工确认的提示时弹窗展示，避免被 toast 一闪而过。 */
export const showPaymentSaveWarnings = (data: unknown): void => {
  const warnings = getSaveWarnings(data);
  if (!warnings.length) {
    return;
  }
  Modal.warning({
    title: '已保存，请确认以下提示',
    content: (
      <ul style={{ paddingLeft: 20, margin: 0 }}>
        {warnings.map(item => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    ),
  });
};
